// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar___Ufkx","nav":"sidebar_nav__nZ4S0","active":"sidebar_active__qwNIW","widget":"sidebar_widget__PXAsl"};